import React, { FC } from 'react';

type Props = {
  name: IconType;
  customClassName?: string;
};

export const Icons: FC<Props> = ({ name, customClassName, ...props }) => {
  switch (name) {
    case 'arrow':
      return (
        <svg
          viewBox="0 0 20 20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          transform="rotate(90)"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <defs> </defs>{' '}
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              {' '}
              <g
                id="Dribbble-Light-Preview"
                transform="translate(-100.000000, -6639.000000)"
              >
                {' '}
                <g id="icons" transform="translate(56.000000, 160.000000)">
                  {' '}
                  <path
                    d="M44,6489 L45.393,6490.435 L53,6482.828 L53,6499 L55,6499 L55,6482.828 L62.586,6490.414 L64,6489 C60.339,6485.339 57.504,6482.504 54,6479 C50.034,6482.966 52.834,6480.166 44,6489"
                    id="arrow_up-[#351]"
                  >
                    {' '}
                  </path>{' '}
                </g>{' '}
              </g>{' '}
            </g>{' '}
          </g>
        </svg>
      );

    case 'arrow-short':
      return (
        <svg
          fill="#000000"
          viewBox="0 0 1920 1920"
          xmlns="http://www.w3.org/2000/svg"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <path
              d="M568.13.012 392 176.142l783.864 783.989L392 1743.87 568.13 1920l960.118-959.87z"
              fillRule="evenodd"
            ></path>{' '}
          </g>
        </svg>
      );

    case 'arrow-circle':
      return (
        <svg
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <title>arrow-down-circle</title>{' '}
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              {' '}
              <g
                id="Icon-Set"
                transform="translate(-412.000000, -1087.000000)"
                fill="#000000"
              >
                {' '}
                <path
                  d="M428,1117 C420.268,1117 414,1110.73 414,1103 C414,1095.27 420.268,1089 428,1089 C435.732,1089 442,1095.27 442,1103 C442,1110.73 435.732,1117 428,1117 L428,1117 Z M428,1087 C419.163,1087 412,1094.16 412,1103 C412,1111.84 419.163,1119 428,1119 C436.837,1119 444,1111.84 444,1103 C444,1094.16 436.837,1087 428,1087 L428,1087 Z M433.121,1102.46 L429,1106.59 L429,1096 C429,1095.45 428.553,1095 428,1095 C427.448,1095 427,1095.45 427,1096 L427,1106.59 L422.879,1102.46 C422.488,1102.07 421.855,1102.07 421.465,1102.46 C421.074,1102.86 421.074,1103.49 421.465,1103.88 L427.121,1109.54 C427.361,1109.78 427.689,1109.85 428,1109.79 C428.311,1109.85 428.639,1109.78 428.879,1109.54 L434.535,1103.88 C434.926,1103.49 434.926,1102.86 434.535,1102.46 C434.146,1102.07 433.512,1102.07 433.121,1102.46 L433.121,1102.46 Z"
                  id="arrow-down-circle"
                >
                  {' '}
                </path>{' '}
              </g>{' '}
            </g>{' '}
          </g>
        </svg>
      );

    case 'close':
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#0F1729"
            ></path>{' '}
          </g>
        </svg>
      );

    case 'alert':
      return (
        <svg
          viewBox="0 0 24.00 24.00"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#000000"
          strokeWidth="0.00024000000000000003"
          className={customClassName}
          {...props}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <path
              d="M12 5.5C12.5523 5.5 13 5.94772 13 6.5L13 13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5L11 6.5C11 5.94772 11.4477 5.5 12 5.5Z"
              fill="#e70808"
            ></path>{' '}
            <path
              d="M12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z"
              fill="#e70808"
            ></path>{' '}
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
              fill="#e70808"
            ></path>{' '}
          </g>
        </svg>
      );

    case 'checked':
      return (
        <svg
          viewBox="0 -0.5 17 17"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <title>1228</title> <defs> </defs>{' '}
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              {' '}
              <path
                d="M3.432,6.189 C3.824,5.798 4.455,5.798 4.847,6.189 L6.968,8.31 L13.147,2.131 C13.531,1.747 14.157,1.753 14.548,2.144 L16.67,4.266 C17.06,4.657 17.066,5.284 16.684,5.666 L7.662,14.687 C7.278,15.07 6.651,15.064 6.261,14.673 L1.311,9.723 C0.92,9.333 0.92,8.7 1.311,8.31 L3.432,6.189 Z"
                fill="#49da0b"
                className="si-glyph-fill"
              >
                {' '}
              </path>{' '}
            </g>{' '}
          </g>
        </svg>
      );

    case 'sale-arrow':
      return (
        <svg
          fill="#000000"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 929.966 929.965"
          xmlSpace="preserve"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <g>
              {' '}
              <path d="M918.364,344.724l-893.5-343.5c-6.6-2.5-14.1-1-19.2,4.1l-0.4,0.4c-5,5-6.6,12.5-4.1,19.2l343.5,893.501 c2.6,6.899,9.2,11.399,16.5,11.5c7.3,0.1,14-4.301,16.8-11.101l109.1-262.2l158.7,158.7c10.2,10.2,26.8,10.2,37,0 c36.5-36.5,95.9-95.899,132.4-132.399c10.2-10.2,10.2-26.801,0-37l-158.5-158.7l262.2-109.101c6.8-2.8,11.199-9.5,11.1-16.8l0,0 C929.764,353.923,925.164,347.323,918.364,344.724z"></path>{' '}
            </g>{' '}
          </g>
        </svg>
      );

    case 'sale-arrow2':
      return (
        <svg
          fill="#000000"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 561.73 561.73"
          xmlSpace="preserve"
          transform="rotate(180)"
          className={customClassName}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <g>
              {' '}
              <g>
                {' '}
                <path d="M21.092,559.965l530.182-53.455c13.078-1.436,14.018-7.112,2.093-12.678L314.5,376.208l216.528-214.273 c4.465-4.419,4.483-11.598,0.043-16.041L420.192,35.015c-4.44-4.44-11.658-4.458-16.123-0.042L186.531,250.247L69.421,10.018 C63.907-1.928,58.207-1.019,56.686,12.053L0.162,538.899C-1.359,551.969,8.01,561.399,21.092,559.965z"></path>{' '}
              </g>{' '}
            </g>{' '}
          </g>
        </svg>
      );

    default:
      return null;
  }
};

type IconType =
  | 'arrow'
  | 'arrow-short'
  | 'close'
  | 'arrow-circle'
  | 'alert'
  | 'checked'
  | 'sale-arrow'
  | 'sale-arrow2';
